import React, { Component } from 'react';

class Radio extends Component {
  static defaultProps = {
    checked: false,
  };

  render() {
    const { checked, onChange } = this.props;

    return (
      <button type="button" className="input-radio" onClick={onChange}>
        <input type="radio" {...this.props} />
        {checked && <span />}
      </button>
    );
  }
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/Form/Radio/index.js